import Alpine from "alpinejs";
import focus from "@alpinejs/focus";
import intersect from "@alpinejs/intersect";
import collapse from "@alpinejs/collapse";

import {
  animateMastersSVG,
  fadeIn,
  fadeInChildren,
  fadeInChildrenLTR,
  fadeInChildrenRTL,
  fadeOutChildren,
  slideInImage,
  slideInImageWithShadow,
} from "./animations";

Alpine.plugin(focus);
Alpine.plugin(intersect);
Alpine.plugin(collapse);

document.addEventListener("alpine:init", () => {
  Alpine.data("document", () => ({
    modalOpen: false,
    menuOpen: false,
    overlayOpen: false,
    init() {
      this.$watch("menuOpen", (open) => {
        if (open) {
          this.focusFirstLink();
          this.fadeInMenuItems();
        }
      });
    },
    openMenu() {
      this.openOverlay();
      this.menuOpen = true;
    },
    openModal() {
      this.openOverlay();
      this.modalOpen = true;
    },
    closeMenu() {
      this.closeOverlay();
      this.menuOpen = false;
    },
    closeModal() {
      this.closeOverlay();
      this.modalOpen = false;
    },
    openOverlay() {
      this.overlayOpen = true;
    },
    closeOverlay() {
      this.overlayOpen = false;
    },
    closeAllOpen() {
      this.closeMenu();
      this.closeModal();
      this.closeOverlay();
    },
    openModalWith(html) {
      this.$refs.modalContent.innerHTML = html;
      this.openModal();
    },
    focusFirstLink,
    fadeInMenuItems,
  }));

  Alpine.store("animate", {
    fadeIn,
    fadeInChildren,
    fadeOutChildren,
    fadeInChildrenLTR,
    slideInImage,
    slideInImageWithShadow,
    animateMastersSVG,
  });
});

function focusFirstLink() {
  const firstLink = document.querySelector<HTMLElement>(
    ".hamburger-menu .menu-item > a"
  )!;

  firstLink?.focus();
}

function fadeInMenuItems() {
  const hamburgerMenu = document.querySelector<HTMLUListElement>(
    "#menu-hamburger-menu"
  )!;

  fadeInChildrenRTL(hamburgerMenu);
}
